import React, { useState } from 'react';
import styled from 'styled-components';
import Grid from '@ntuctech/devex-tangram/Grid';
import { SvgAddCircleFilled } from '@ntuctech/devex-tangram/Icon';
import Input from '@ntuctech/devex-tangram/Input';
import Radio from '@ntuctech/devex-tangram/Radio';
import AddReceipnt from './AddReceipnt';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';

const WhiteBox = styled.div`
  .no-spacing {
    padding: 0 !important;
    margin: 0 !important;
  }
  background-color: #fff;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  @media screen and (min-width: 600px) {
    border: 1px solid #eaeaea;
  }
  ${SCREEN_SIZE.From.Desktop} {
    padding: 2rem;
  }
  ${SCREEN_SIZE.Only.Tablet} {
    padding: 1.5rem;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    padding: 1rem;
    border: 0;
    border-radius: 0;
  }
`;

const RmvInnerPad = styled.div`
  @media screen and (min-width: 768px) {
    > div:nth-child(1) {
      padding: 0 0.5rem;
    }
  }
`;

const BoxTitle = styled.h5`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #333333;
  margin: 0;
`;

const InputSection = styled.div`
  > div:hover input {
    border-color: #666666 !important;
  }
  > div:hover label {
    color: inherit !important;
  }
  > div input:hover {
    border-color: #1454b8 !important;
  }
  > div {
    margin-bottom: 0;
    width: 100%;
    margin-top: 15px;
  }
  > div div {
    width: 100%;
  }
  input {
    max-width: 328px;
    margin: 0 auto 0 0;
    :-webkit-autofill,
    :-webkit-autofill:hover,
    :-webkit-autofill:focus,
    :-webkit-autofill:active {
      box-shadow: 0 0 0 30px white inset !important;
    }
  }
  input[type='date'] {
    width: 167px;
  }
  @media screen and (max-width: 768px) {
    input {
      max-width: 100%;
    }
  }
`;

const RadioSection = styled.div`
  margin-top: 15px;
  position: relative;
  > label:nth-child(1) {
    margin-right: 45px;
  }
`;

const AddRecipient = styled.div`
  margin-top: 15px;
  span {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #1557bf;
    position: relative;
    top: -6px;
    left: 5px;
    cursor: pointer;
  }
`;

const radio = [
  {
    value: 'email',
    label: 'Send via email',
  },
  {
    value: 'sms',
    label: 'Send via SMS',
  },
];

const RecipientSection = (props) => {
  const {
    voucherData,
    setVoucherData,
    Agreegate,
    counterInputRef,
    recepient,
    setRecepient,
    AgreegateRecipient,
    dummyarray,
  } = props;

  const [error, setError] = useState('');

  const addReceipnt = () => {
    let test = dummyarray;
    test = {
      ...test,
      deliveryMethod: voucherData.receivers[0].deliveryMethod,
    };
    setRecepient([...recepient, test]);
    setVoucherData({ ...voucherData, receivers: [...recepient, test] });
  };
  /* eslint-disable radix */

  const ChangeDeliveryMethod = (value) => {
    const newArr = voucherData.receivers.map((obj) => {
      return { ...obj, deliveryMethod: value };
    });
    setVoucherData({
      ...voucherData,
      receivers: [...newArr],
    });
    Agreegate(newArr, setRecepient);
  };

  const getHelperTextSender = () => {
    return 'Maximum length 36';
  };

  return (
    <>
      <WhiteBox>
        <RmvInnerPad>
          <Grid container className="no-spacing">
            <Grid item xs={12} className="no-spacing">
              <BoxTitle>Sender details</BoxTitle>
              <InputSection>
                <Input
                  ref={counterInputRef}
                  data-testid="sender-name"
                  label="Name"
                  type="text"
                  name="SenderName"
                  placeholder="Enter name"
                  tabindex="-4"
                  maxLength={36}
                  required
                  error={error}
                  value={voucherData.sender || ''}
                  helpText={getHelperTextSender()}
                  onChange={(event) => {
                    setVoucherData({
                      ...voucherData,
                      sender: event.target.value,
                    });
                  }}
                  onBlur={() =>
                    setError(voucherData && voucherData.sender && voucherData.sender.length > 36)
                  }
                />
              </InputSection>
            </Grid>
          </Grid>
        </RmvInnerPad>
      </WhiteBox>
      <WhiteBox>
        <RmvInnerPad>
          <Grid container className="no-spacing">
            <Grid item xs={12} className="no-spacing">
              <BoxTitle>Recipient details</BoxTitle>
              <RadioSection>
                {radio.map((item, index) => (
                  <Radio
                    key={`${item.label}-${item.value}`}
                    data-testid={`SendVia-${index}`}
                    onChange={(event) => {
                      ChangeDeliveryMethod(event.target.value);
                    }}
                    label={item.label}
                    name="SendVia"
                    value={item.value}
                    checked={voucherData.receivers[0].deliveryMethod === item.value}
                  />
                ))}
              </RadioSection>
              {recepient.map((recData, index) => {
                return (
                  <AddReceipnt
                    key={`recipient-${voucherData.sender}`}
                    recData={recData}
                    index={index}
                    recepient={recepient}
                    AgreegateRecipient={AgreegateRecipient}
                    setRecepient={setRecepient}
                    voucherData={voucherData}
                    setVoucherData={setVoucherData}
                    counterInputRef={counterInputRef}
                  />
                );
              })}
              {recepient.length < 10 && (
                <AddRecipient data-testid="add-recipient" onClick={() => addReceipnt()}>
                  <SvgAddCircleFilled size="m" color="#1454b8" cursor="pointer" />
                  <span>Add another recipient</span>
                </AddRecipient>
              )}
            </Grid>
          </Grid>
        </RmvInnerPad>
      </WhiteBox>
    </>
  );
};
export default RecipientSection;
